import { EMasterTabs } from '../../types/masterFilters';
import { ITypedReduxAction } from '../../types/redux/actionType';

export type TMasterTabsPayload = {
  value: EMasterTabs;
};

export type TMasterSubAgentPayload = {
  subAgentId: number;
};

export enum EMasterFiltersActionTypes {
  SetActiveTab = 'masterFilters/setActiveTab',
  SelectSubAgent = 'masterFilters/selectSubAgent',
  UnselectSubAgent = 'masterFilters/unselectSubAgent',
}

export type TMasterFiltersActions =
  | ITypedReduxAction<EMasterFiltersActionTypes.SetActiveTab, TMasterTabsPayload>
  | ITypedReduxAction<EMasterFiltersActionTypes.SelectSubAgent, TMasterSubAgentPayload>
  | ITypedReduxAction<EMasterFiltersActionTypes.UnselectSubAgent, void>;
